
import { Component, Vue, Prop } from 'vue-property-decorator';
import NoDataSelectItem from '@/components/selectItems/NoDataSelectItem.vue';
import CommonSelectItem from '@/components/selectItems/CommonSelectItem.vue';
import { getMaxlengthValidationRule, requiredValidationRule } from '@/helpers/validationRules';

@Component({
  components: {
    NoDataSelectItem,
    CommonSelectItem,
  },
})
export default class CompanyNameComboboxField extends Vue {
  @Prop(String) public value: string;
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;
  @Prop(Array) public items: string[];

  get fieldValue() {
    return this.value;
  }

  set fieldValue(value) {
    this.$emit('input', value || '');
  }

  public maxlength = 30;
  public fieldValidationRules = [requiredValidationRule, getMaxlengthValidationRule(this.maxlength)];
}
